<template>
  <div>

 <b-modal @hidden="resetModal" size="md" id="editProductModal" title="Edit Product" ok-title="Save" @ok="handleOk" ref="editProductModal">


        <b-form ref="editProductForm" @submit.prevent="handleSubmit">
          <b-form-row>
            <b-col>
              <b-form-group label="Product Title" label-for="productTitle">
                <b-form-input id="productTitle" type="text" v-model="productForm.productTitle" placeholder="Product Title">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col>
              <b-form-group id="availGroupEdit" label="Available" label-for="availEdit">
        <b-form-select
          id="availEdit"
          v-model="productForm.avail"
          :options="opts"
        ></b-form-select>
      </b-form-group>
            </b-col>
          </b-form-row>
          <b-form-row>
            <b-col>

              <b-form-group label="Price" label-for="price">
                <b-form-input id="price" type="number" v-model.number="productForm.price">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col>


              <b-form-group label="Total Stock" label-for="totalStock">
                <b-form-input id="totalStock" type="number" v-model.number="productForm.totalStock">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-form-row>

          <button type="submit" ref="submitBtn" v-show="false">Create</button>

        </b-form>

      </b-modal>
    </div>
    </template>
    <script>
    export default {
      name: 'EditProductModal',
      data() {
        return {
          productForm: {
            productId: null,
            productTitle: null,
            price: null,
            avail: null,
            totalStock: null,
          },
          opts: [
            true,false
          ],
        }
      },
      props: [
        'id',
      ],
      watch: {
        id: function(val) {
          // console.log(`edit product ID changed to ${val}`)
          let product = this.products.find(p=> p.productId == val)
          if(!product) return console.error(`no product with id ${val}`)
          this.productForm.productId = val
          this.productForm.totalStock = product.totalStock
          this.productForm.price = product.price
          this.productForm.avail = product.avail
          this.productForm.productTitle = product.productTitle

        }
      },
      computed: {
        products() {
          return this.$store.state.products.products
        }
      },
      methods: {
        handleOk(e){
          // console.log('handleOk called')
          e.preventDefault()
          this.$refs.submitBtn.click()
        },
        handleSubmit(e){
          console.log(`editProduct form submitted`)
          let {productTitle,price,totalStock} = this.productForm
          if(!productTitle || !price || !totalStock) return console.error('incomplete form')
          console.log(`editing product ${productTitle} with stock ${totalStock} and price ${price}`)
          this.$store.dispatch('products/editProduct',this.productForm)
          this.$refs.editProductForm.reset()
          this.$nextTick(() => {
        this.$refs.editProductModal.hide()
      })

    },
    resetModal() {
      /*this.productForm =  {
        productId: null,
        productTitle: null,
        price: null,
        avail: null,
        totalStock: null,
      }*/
    }
      }
    }
    </script>
